module.exports = __webpack_public_path__ + "img/fishing-site-img.c65e8fdc.jpg";